import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import _ from 'lodash';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { generateValidationSchema } from 'src/utils/validation';
import { FormProvider, useForm } from 'react-hook-form';
import { ajvResolver } from '@hookform/resolvers/ajv';
import { FormFieldDefinition } from '@publishing-engine/domain/types/article';
import { FormFieldMultipleFileUpload } from 'src/components/FormField';
import { FormFieldFileList } from '.';
import { checkFileUpload } from 'src/pages/Organization/public/Journal';
import { ISubmissionFieldsResponse } from '@publishing-engine/submission-service/src/usecases/submission-fields/types';

export type IFileValue = {
  fileSet: {
    [x: string]: ISubmissionFile[];
  };
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (value: IFileValue) => void;
  formField: FormFieldFileList;
  value?: ISubmissionFile[];
  submissionContextId: string;
  referenceName?: string;
  submissionId: string;
  SubmissionFieldsResponse: ISubmissionFieldsResponse;
}

const FileListUploadModal: React.FC<Props> = props => {
  const {
    isOpen,
    onClose,
    formField,
    onSubmit,
    submissionContextId,
    submissionId,
    SubmissionFieldsResponse
  } = props;

  const defaultValues = _.set(
    {} as IFileValue,
    formField.caseDataFields.main,
    props.value
  );

  const schema = generateValidationSchema({
    [formField.name]: formField
  } as Record<string, FormFieldDefinition>);

  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });

  const checkIsFileLoading = () => {
    const values = methods.getValues();
    const status = checkFileUpload(values.fileSet);
    return status;
  };

  const isFileUploading = checkIsFileLoading();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <button></button>
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(data => {
            onSubmit(data);
            onClose();
          })}
        >
          <Flex
            padding={8}
            gap={6}
            bgColor="surfacePrimaryFill"
            flexDirection="column"
            borderRadius="base"
          >
            <Flex maxHeight={700} overflow={'auto'}>
              <FormFieldMultipleFileUpload
                submissionContextId={submissionContextId}
                config={formField}
                submissionId={submissionId}
                submissionFields={SubmissionFieldsResponse}
              />
            </Flex>
            <Flex
              gap={2}
              justifyContent="flex-end"
              alignItems="center"
              alignSelf="stretch"
            >
              <Button
                variant="secondary"
                onClick={onClose}
                borderRadius="small"
                disabled={isFileUploading}
              >
                Exit Without Saving
              </Button>
              <Button
                variant="primary"
                type="submit"
                borderRadius="small"
                disabled={isFileUploading}
              >
                Save Changes
              </Button>
            </Flex>
          </Flex>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default FileListUploadModal;
